<div class="basic-radio" [ngClass]="[disabled ? 'disabled' : '', hasError ? 'error' : '', isChecked ? 'checked' : 'unchecked']">
  <button
    type="button"
    class="radio-button"
    [attr.role]="checkboxMode ? 'checkbox' : 'radio'"
    [attr.aria-checked]="isChecked"
    [attr.aria-disabled]="disabled"
    [attr.aria-label]="label || value"
    [disabled]="disabled"
    (click)="select()"
    tabindex="0"
  >
    <span class="radio-outer">
      <svg
        *ngIf="isChecked"
        class="radio-inner"
        xmlns="http://www.w3.org/2000/svg"
        width="7"
        height="7"
        viewBox="0 0 7 7"
        fill="none"
      >
        <circle cx="3.5" cy="3.5" r="3.5" fill="white"/>
      </svg>
    </span>
  </button>
  <span class="radio-label" *ngIf="label" (click)="select()">{{ label }}</span>
</div>

